import styled from 'styled-components';
import colors from "assets/styles/colors";

export default styled.div`
    .groupByWrapper {
        display: flex;
        margin-top: 15px;
    }

    .groupBySelect {
        min-width: 200px;

        label {
            letter-spacing: 0.1em;
            color: ${colors.textNavy};
        }
    }
`;